(function(){
    'use strict';

    angular.module('Directives').directive('bbaPostcodeBasedMargins', bbaPostcodeBasedMargins);
    
    bbaPostcodeBasedMargins.$inject = [
        '$timeout',
        'PostcodeBaseMarginsTableService'
    ];

    function bbaPostcodeBasedMargins(
        $timeout,
        PostcodeBaseMarginsTableService
    )
    {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/margins/bba-postcode-base-margins.html',
            require: ['^form', '^ngModel'],
            scope: {
                clearTable: '=?',
                isViewMode: '=?',
                ngModel: '=',
                ngOriginalData: '='
            },
            link: bbaPostcodeBasedMarginsLink
        }

        function bbaPostcodeBasedMarginsLink($scope, element, attr, ngModels){
            $scope.postcodeBaseMarginsTableService = new PostcodeBaseMarginsTableService(
                ngModels[0],
                $scope.ngModel
            );
    
            $scope.addNewMargin = $scope.postcodeBaseMarginsTableService.addNewMargin;
            $scope.postcodeMarginTable = $scope.postcodeBaseMarginsTableService.tableData;

            $scope.$watch('ngModel', (newValue, oldValue) => {
                if(newValue && angular.getObjVal(newValue, 'postcodeMargins.regions')){
                    $scope.postcodeMarginTable = new PostcodeBaseMarginsTableService(
                        ngModels[0],
                        $scope.ngModel
                    );
                    $scope.addNewMargin = $scope.postcodeMarginTable.addNewMargin;
                    $scope.postcodeMarginTable = $scope.postcodeMarginTable.tableData;
                }
            });

            let listener = $scope.$on('postcodeBasedMarginsTableUpdate', function(data){
                $timeout(function(){
                    $scope.ngModel.postcodesRaw = $scope.postcodeBaseMarginsTableService.getPostcodeMarginFormatted();
                    $scope.ngModel.marginsFrmOpen = $scope.postcodeBaseMarginsTableService.getOpenForms();
                });
            });

            $scope.$on('$destroy', function(){
                listener();
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/margins/bbaPostCodeBaseMargins.js